<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    $route() {
      if (this.$route.meta.title) {
        document.title = this.$route.meta.title;
      }
    },
  },
  methods: {
    toJSON() {},
  },
};
</script>

<style lang="less">
body {
  margin: 0;
}
</style>
